import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import type { Attachment } from '@recruitee/attachments-types';
import { AttachmentItemComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AttachmentItemComponent],
})
export class AttachmentsListComponent {
  @Input() public attachments: Attachment[];
  @Input() public deletable: boolean = false;
  @Input() public small: boolean = false;
  @Input() public candidateActionsEnabled: boolean = false;
  @Input() public moreTemplate: TemplateRef<any>;
  @Input() public hasSetAsCoverLetterAction: boolean = false;
  @Input() public canManageCandidates = false;
  @Output() public deleteClick: EventEmitter<Attachment> = new EventEmitter();
  @Output() public setAsCv: EventEmitter<Attachment> = new EventEmitter();
  @Output() public setAsCoverLetter: EventEmitter<Attachment> = new EventEmitter();

  public trackByAttachment(index: number, attachment: Attachment): number {
    return attachment.id;
  }
}
